import React from 'react'
import store from '../../store/Store'
import { withRouter } from 'react-router-dom'
import routes from '../../routes/Routes'

import actionTypes from '../../actionTypes/actionTypes'
import actions from '../../actions/Actions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import IconButton from '@material-ui/core/IconButton'

import Navigation from '../navigation/Navigation'

import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'

import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'

import './login.scss'

type loginState = {
	username: any;
	password: any;
	error: boolean;
	errorMessage: any;
	history: any;
}

type loginProps = {
	history: any;	
}

class Login extends React.Component<loginProps, loginState> {

  constructor(props) {
  	super(props)

  	// console.log(props)

  	this.state = {
  		history: props.history,
  		username: '',
  		password: '',
  		error: false,
  		errorMessage: ''
  	}
  }

  componentDidMount() {
  	// console.log('Login Did Mount')
  	
	store.subscribe(() => {
		this.setState({
			
		})
	})
  }

  	componentWillUnmount() {
  		// console.log('Login Will Unmount')

		store.subscribe(() => {
			this.setState({
				
			})
		})
	}

  login = () => {
  	// console.log('Login')

  	const {
  		history,
  		username, 
  		password
  	} = this.state

  	actions.loginActions.requestLogin({ user: { username: username, password: password }}).then((res) => {
  		if (res && res.errorMessage != null) {
  			this.setState({
  				password: '',
  				error: !res.success,
  				errorMessage: res.errorMessage
  			})

  			return
  		}

  		store.dispatch({
			type: actionTypes.CHANGE_ROUTE,
			data: {
				route: routes.ROUTE_OVERVIEW
			}
		})

	  	store.dispatch({
	  		type: actionTypes.REQUEST_LOGIN,
	  		data: res
	  	})

	  	history.push(routes.ROUTE_OVERVIEW)
  	}).catch((err) => {
  		console.log('Login Error: ' + err)
  	})
  }

  register = () => {
  	console.log('Register')

  	const {
  		history
  	} = this.state

	store.dispatch({
		type: actionTypes.CHANGE_ROUTE,
		data: {
			route: routes.ROUTE_REGISTER
		}
	})

	store.dispatch({
		type: actionTypes.REQUEST_REGISTER,
		data: {
			register: true
		}
	})

	history.push( routes.ROUTE_REGISTER )
  }

  onChangeUsername = (event) => {
  	this.setState({
  		username: event.target.value
  	})
  }

  onChangePassword = (event) => {
  	this.setState({
  		password: event.target.value
  	})
  }

  render() {
  	const { error, errorMessage, username, password } = this.state

	  return (
	  	<div
	  		className="Login"
	  	>

		       		{
		  			error ? (
		  				<FormControl
		      	style={{
		      		margin: '0 12px 0 6px'
		      	}}
		      >
		  		<FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		  					{ errorMessage }
		  				</FormHelperText>
		        </FormControl>
		  			) : null
		  		}   	

		      <FormControl
		      	style={{
		      		margin: '0 12px 0 6px'
		      	}}
		      >

		          <Input
		            id="standard-adornment-weight-username"
		            onChange={ (event) => { this.onChangeUsername(event) } }
		            aria-describedby="standard-weight-helper-text"
		            value={ username }
		            inputProps={{
		              'aria-label': 'Username'
		            }}
		          />
		          <FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		          	Username
		          </FormHelperText>
		        </FormControl>

		      <FormControl
		      	style={{
		      		margin: '0 6px 0 12px'
		      	}}
		      >
		          <Input
		            id="standard-adornment-weight-password"
		            onChange={ (event) => { this.onChangePassword(event) } }
		            type="password"
		            aria-describedby="standard-weight-helper-text"
		            value={ password }
		            inputProps={{
		              'aria-label': 'Password'
		            }}
		          />
		          <FormHelperText 
		          	id="standard-weight-helper-text"
		          	style={{
			      		margin: '6px 0 0 0',
			      		color: error ? 'rgba(255, 0, 0, 1)' : 'rgba(0, 0, 0, 1)'
			      	}}
		          >
		          	Password
		          </FormHelperText>
		        </FormControl>
		
			<IconButton
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={
	            	() => this.login()
	            }
	          >
	            <LockOpenIcon />
	          </IconButton>

	          <IconButton
	            edge={ 'end' }
	            className={ 'MenuButton' }
	            color="inherit" 
	            aria-label="menu"
	            onClick={
	            	() => this.register()
	            }
	          >
	            <AssignmentOutlinedIcon />
	          </IconButton>
		</div>
	  );
	}
}

export default withRouter(Login)